<script>
import { authComputed } from '@state/helpers'

export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    hide() {
      this.$parent.toggleRightSidebar()
    },
  },
}
</script>

<template>
  <div>
    <!-- Right Sidebar -->
    <div class="right-bar">
      <div class="rightbar-title">
        <a
          href="javascript:void(0);"
          class="right-bar-toggle float-right"
          @click="hide"
        >
          <i class="fad fa-x noti-icon"></i>
        </a>
        <h5 class="m-0 text-white">{{ title }}</h5>
      </div>
      <div class="slimscroll-menu px-2">
        <slot />
      </div>
      <!-- end slimscroll-menu-->
    </div>
    <!-- /Right-bar -->

    <!-- Right bar overlay-->
    <div class="rightbar-overlay"></div>
  </div>
</template>

<style lang="scss"></style>
